// extracted by mini-css-extract-plugin
export const item = "AccordionTextItem-module--item--2E1NQ";
export const header = "AccordionTextItem-module--header--1BNXk";
export const title = "AccordionTextItem-module--title--3D-jw";
export const content = "AccordionTextItem-module--content--1gDRo";
export const itemColorWhite = "AccordionTextItem-module--item-color-white--2hYai";
export const itemColorGray = "AccordionTextItem-module--item-color-gray--3SX1Z";